import axios from "axios";
import type { CompanyProps, EventProps, GroupPlayerProps, GroupProps, LeagueProps, PlayerSquareProps, SquareOfferProps, SquarePrizeProps, SquareProps, SquareResultProps, SquaresCompetitionProps, SquaresPayoutProps, SquaresTypeProps } from "../../types";
import { APIOverrides } from "../../ApiOverrides";
import type { CompanyMemberProps } from "../../Authenticator/api/types";

let AUTH_SVC_API = ''
let TP_SVC_API = ''
let EVENT_SVC_API = ''
let SOCIAL_SVC_API = ''
export { SquaresManagerApi }


const SquaresManagerApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        TP_SVC_API = endpoints['TP_SVC_API'] as string;
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        //MK_SVC_API = endpoints['MK_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
    },
    getLeagues: async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues`);
            return resp.data.leagues
        } catch (e) {
            return []
        }
    },
    deleteCompetition: async(sq_comp_id:string):Promise<SquaresCompetitionProps|undefined> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/squares/competition/delete`, { sq_comp_id });
            return resp.data.squares_competition
        } catch (e) {
            return undefined
        }
    },
    getEventsByEventIds: async(event_ids:string[]):Promise<EventProps[]> => {
        try {
            if(event_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/events/bulk/get`, { attribute:'event_id', values: event_ids })
            return resp.data.events
        } catch (e) {
            return []
        }
    },
    getSquareCompetitionById: async(sq_comp_id:string):Promise<undefined | { squares_competition:SquaresCompetitionProps, square_results:SquareResultProps[], squares:SquareProps[], player_squares:PlayerSquareProps[], square_offers:SquareOfferProps[], squares_type:SquaresTypeProps, squares_payout_type: SquaresPayoutProps, player_square_history:PlayerSquareProps[], square_prizes:SquarePrizeProps[] }> => {
        try {
            const resp = await axios.get(`${TP_SVC_API}/tp/squares/comp/details/${sq_comp_id}`)
            return resp.data
        } catch (e) {
            return undefined
        }
    },
    updateSquaresCompetition: async(squares_competition:SquaresCompetitionProps):Promise<SquaresCompetitionProps|undefined> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/squares/competition/update`, { squares_competition });
            return resp.data.squares_competition
        } catch (e) {
            return undefined
        }
    },
    getMyCompanies : async():Promise<{companies:CompanyProps[], company_members:CompanyMemberProps[]}> => {
        const resp = await axios.get(`${AUTH_SVC_API}/v1/companies/me`)
        const { companies, company_members } = resp.data
        return { companies, company_members }
    },
    getMyGroups: async(offset:number):Promise<{groups: GroupProps[], group_players:GroupPlayerProps[]}> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v2/groups/me/multiple?offset=${offset}`);
            return resp.data
        } catch (e) {
            return { group_players: [], groups: [] }
        }
    },

    createSquaresCompetition: async(squares_competition:SquaresCompetitionProps):Promise<SquaresCompetitionProps | undefined> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/squares/competition/create`, { squares_competition });
            return resp.data.squares_competition
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    activateSquares: async(sq_comp_id:string):Promise<undefined | { squares_competition:SquaresCompetitionProps }> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/squares/competition/activate`, { sq_comp_id });
            return resp.data
        } catch (e) {
            return undefined
        }
    }
}


export const SquaresManagerHelpers = {
    isValid: (draft_squares?:SquaresCompetitionProps, minimum_square_price?:string, guaranteed_payout?:string) => {
        if(!draft_squares){ return ['Invalid'] }
        let errors:string[] = []
        if(!draft_squares){ errors.push('Please complete steps'); return errors }
        if(!draft_squares.sq_comp_name){ errors.push('Please add a squares name') }
        if(!draft_squares.sq_comp_description){ errors.push('Please add a description') }
        if(!draft_squares.event_id){ errors.push('Please add an event') }
        if(!minimum_square_price){ errors.push('Please add a square price') }
        if(minimum_square_price){
            let int_price = parseFloat(minimum_square_price)
            if(isNaN(int_price)){ errors.push('Minimum square price is not valid') }
            if(int_price < 0.5){ errors.push('Minimum square price must be at least 50 cents') }
        }
        if(guaranteed_payout){
            let int_payout = parseFloat(guaranteed_payout)
            if(isNaN(int_payout)){ errors.push('Guaranteed payout is not valid') }
            if(int_payout < 0){ errors.push('Guaranteed payout cannot be negative') }
        }
        return errors
    }
}